import Constants from '../../constants';

export default {
	getPricing: () => ({
		type: Constants.GCP_GET_PRICING
	})
};



// WEBPACK FOOTER //
// ./src/actions/gcp/pricingActions.js